import { ArrowRight, CircleCheck } from 'lucide-react';
import { Link } from 'react-router';

import { Container } from '@/components/ui/Container';
import { CTA_BAND } from '@/data/homeContent';

/**
 * The closing band.
 *
 * The bundled wordmark artwork has a near-white "Neon" in it, so this dark
 * panel is one of the few places it can be used as an image rather than
 * rebuilt as live text.
 */
export function CtaBand() {
  return (
    <section aria-labelledby="home-cta" className="bg-brand-cta py-10 sm:py-12">
      <Container className="flex flex-col items-center gap-6 text-center lg:flex-row lg:justify-between lg:gap-10 lg:text-start">
        <div className="flex flex-col items-center gap-3 lg:flex-row lg:items-center lg:gap-4">
          <img
            src="/images/logo-full.png"
            alt="NeonCarts"
            className="w-40 shrink-0 sm:w-48"
            loading="lazy"
            width={564}
            height={193}
          />
          <p className="max-w-xs text-sm leading-relaxed text-white/70">{CTA_BAND.blurb}</p>
        </div>

        <div className="lg:flex-1">
          <h2
            id="home-cta"
            className="text-balance text-xl font-bold tracking-tight text-white sm:text-2xl"
          >
            {CTA_BAND.heading}
          </h2>
          <ul className="mt-3 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 lg:justify-start">
            {CTA_BAND.ticks.map((tick) => (
              <li key={tick} className="flex items-center gap-1.5 text-xs text-white/70">
                <CircleCheck className="size-3.5 shrink-0 text-brand-400" aria-hidden />
                {tick}
              </li>
            ))}
          </ul>
        </div>

        <Link
          to={CTA_BAND.cta.to}
          className="inline-flex h-12 shrink-0 items-center gap-2 rounded-xl bg-brand-500 px-6 text-sm font-semibold text-white transition-colors hover:bg-brand-400 sm:text-base"
        >
          {CTA_BAND.cta.label}
          <ArrowRight className="size-4 rtl-flip" aria-hidden />
        </Link>
      </Container>
    </section>
  );
}
